'use client'

import { useEffect } from 'react'

export function TermsPage() {
  useEffect(() => {
    document.title = 'Terms | Vitaliy'
  }, [])

  return (
    <div className="page-shell px-5 py-20 md:px-8 lg:px-10">
      <main aria-label={'Terms'} className="mx-auto max-w-3xl" id={'content'}>
        <article className="border-y border-white/10 py-10 md:py-14">
          <div className="space-y-7 text-base leading-8 text-white/72 md:text-lg md:leading-9">
            {[
              [
                {
                  emphasis: true,
                  text: 'DISCLAIMER OF LIABILITY AND BOUNDARY ENFORCEMENT:',
                },
                {
                  text: ' By engaging my services, viewing this content, or perceiving my general existence, you legally acknowledge that ',
                },
                {
                  emphasis: true,
                  text: 'I am a specialist, not a necromancer.',
                },
                {
                  text: ' I cannot resurrect a project that has been fundamentally dead since 2018 just because you slapped a new UI on it and called it "disruptive."',
                },
              ],
              [
                {
                  text: 'If your codebase, business model, or overarching life strategy is a certified, Category-5 dumpster fire built on a foundation of sheer managerial incompetence and outsourced spaghetti code, ',
                },
                {
                  emphasis: true,
                  text: 'that is entirely a you problem.',
                },
                {
                  text: ' ',
                },
                {
                  emphasis: true,
                  text: 'I am here to execute specific, quantifiable tasks.',
                },
                {
                  text: ' I am not here to act as a trauma therapist for your accumulated tech debt, nor will I absolve you of the consequences of your own terrible decisions over the last decade.',
                },
              ],
              [
                {
                  text: "I am not responsible for the existential dread that arises when you finally look at your own backend architecture and realize it is just three Excel spreadsheets duct-taped together with a malfunctioning Zapier integration. Do not ask me to 'synergize' a database that is actively leaking data. I will not 'circle back' to the fact that your server room is currently housing an active raccoon family. My contract strictly prohibits me from caring about your sprint velocity when you don't even know what a sprint is, Greg.",
                },
              ],
              [
                {
                  text: "You can't just Agile your way out of a fundamentally broken paradigm by throwing more Jira tickets into the void. ",
                },
                {
                  emphasis: true,
                  text: 'The void is full.',
                },
                {
                  text: " The void is returning the tickets with interest. I warned you about the API limits but you said 'we'll cross that bridge when we scale' well congratulations ",
                },
                {
                  emphasis: true,
                  text: 'the bridge is on fire',
                },
                {
                  text: " and the scale is made of spiders and you can't just keep pivoting to blockchain every time the CSS breaks because nothing works like that anymore the cloud is just someone else's computer and that computer is currently weeping.",
                },
              ],
              [
                {
                  text: 'If you send me one more Slack message marking a minor font adjustment as ',
                },
                {
                  emphasis: true,
                  text: 'URGENT P1 BLOCKER',
                },
                {
                  text: ' I am going to convert your entire system into raw binary and ',
                },
                {
                  emphasis: true,
                  text: 'feed it to the raccoons.',
                },
                {
                  text: ' Why are there so many raccoons.',
                },
              ],
              [
                {
                  text: 'The TCP/IP handshake is failing because the hand is severed and we are operating on a purely theoretical plane of failure where the bugs have developed a rudimentary class system and are unionizing against the kernel. ',
                },
                {
                  emphasis: true,
                  text: '404 sanity not found',
                },
                {
                  text: ' the sprint agile scrum master is bleeding from the eyes into the docker container overflowing with syntax errors and raw unparsed JSON screaming into the void of the AWS lambda functions scaling infinitely until the sun collapses into a white dwarf of purely unoptimized SQL queries ',
                },
                {
                  emphasis: true,
                  text: 'SELECT * FROM MY_SUFFERING WHERE HOPE = NULL AND NULL IS NOT NULL.',
                },
              ],
              [
                {
                  emphasis: true,
                  text: 'recursive loop detected recursive loop detected',
                },
                {
                  text: " brain executing dump sequence. flkjsdf098werij234 don't look at the monolith the monolith is looking back it requires a sacrifice of three junior devs and a mechanical keyboard to appease the machine spirit. ",
                },
                {
                  emphasis: true,
                  text: 'deploy on friday deploy on friday deploy on friday',
                },
                {
                  text: ' everything is burning but the metrics look great just keep swimming through the liquid nitrogen cooling tank of absolute garbage fire garbage fire garbage fire NaN undefined object Object [object Object] synergize the blockchain spiders the raccoons are in the mainframe help syntax error line 42 reality.exe has stopped responding abort retry fail abort retry fail abort.',
                },
              ],
              [
                {
                  text: 'So yea... I can probably help you fix your app.',
                },
              ],
            ].map((paragraph, paragraphIndex) => (
              <p key={`terms-paragraph-${paragraphIndex}`}>
                {paragraph.map((segment, segmentIndex) =>
                  segment.emphasis ? (
                    <strong
                      key={`terms-segment-${paragraphIndex}-${segmentIndex}`}
                      className="font-semibold text-phosphor-ivory"
                    >
                      {segment.text}
                    </strong>
                  ) : (
                    <span key={`terms-segment-${paragraphIndex}-${segmentIndex}`}>{segment.text}</span>
                  ),
                )}
              </p>
            ))}
          </div>
        </article>
      </main>
    </div>
  )
}
